/* eslint-disable prefer-const */
import clsx from 'clsx'
import { Field, Form, Formik } from 'formik'
import React from 'react'
import { Modal } from 'react-bootstrap'
import 'react-datepicker/dist/react-datepicker.css'
import * as Yup from 'yup'
import { ICampaignProps } from './creation/CampaignCreationModal'

interface CampaignCreationModalProps {
  showModal: boolean
  setShowModal: (showModal: boolean) => void
  submitCallback: (values: ICampaignProps) => void
  onClose: () => void
  initialValues: () => ICampaignProps
}

const CampaignEditModal: React.FC<CampaignCreationModalProps> = ({
  showModal,
  setShowModal,
  initialValues,
  submitCallback,
  onClose,
}) => {
  const campaignSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
    description: Yup.string(),
    level: Yup.string(),
    unit: Yup.string(),
    goal: Yup.string(),
    useFacebookColor: Yup.boolean(),
  })
  const [loading] = React.useState(false)

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size='lg' keyboard={false}>
      <div className='modal-body'>
        <div>
          <Formik
            initialValues={initialValues()}
            enableReinitialize
            validationSchema={campaignSchema}
            onSubmit={(values) => {
              submitCallback(values)
            }}
          >
            {({ errors, touched }) => (
              <Form>
                <div>
                  <h3 className='fw-bolder my-2'>Rediger kampanje</h3>
                </div>
                <div className='row mb-3 mt-7'>
                  <label className='col-lg-3 col-form-label fw-bold fs-6'>Navn:</label>
                  <div className='col-lg-9 fv-row'>
                    <Field
                      style={{ borderRadius: '8px' }}
                      type='text'
                      name='name'
                      className={clsx(
                        'form-control form-control-lg form-control-solid inputClass',
                        {
                          'is-invalid': touched.name && errors.name,
                        }
                      )}
                      placeholder='Angi tittel på kampanje'
                    />
                  </div>
                </div>

                <div className='row mb-3 mt-7'>
                  <label className='col-lg-3 col-form-label fw-bold fs-6'>Beskrivelse:</label>
                  <div className='col-lg-9 fv-row'>
                    <Field
                      style={{ borderRadius: '8px' }}
                      type='text'
                      name='description'
                      className={clsx(
                        'form-control form-control-lg form-control-solid inputClass',
                        {
                          'is-invalid': touched.description && errors.description,
                        }
                      )}
                      placeholder='Kort beskrivelse av kampanjen'
                    />
                  </div>
                </div>
                <div className='row mb-6'>
                  <div className='col-lg-12'>
                    <div className='form-check form-check-custom form-check-solid'>
                      <Field
                        type='checkbox'
                        name='useFacebookColor'
                        className='form-check-input'
                        id='useFacebookColor'
                      />
                      <label className='form-check-label' htmlFor='useFacebookColor'>
                        Bruk facebook farge for landingsside
                      </label>
                    </div>
                  </div>
                </div>
                <div className=' d-flex justify-content-between mt-2'>
                  <button
                    type='button'
                    className='btn btn-light me-3'
                    style={{ color: '#3F4254', marginLeft: '-4px' }}
                    onClick={() => {
                      onClose()
                      setShowModal(false)
                    }}
                  >
                    Avbryt
                  </button>
                  <button
                    type='submit'
                    className='btn btn-lg btn-primary authbgcolor'
                    disabled={loading}
                  >
                    {!loading && <span className='indicator-label'>Lagre</span>}
                    {loading && (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        Vennligst vent...
                        <span className='spinner-border spinner-border-sm align-middle ms-2' />
                      </span>
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  )
}

export default React.memo(CampaignEditModal)
